<div class="toggle">
  <input class="toggle-input" type="checkbox" />
  <div class="toggle-container">
    <p *ngIf="offLabel" class="label label--previous">{{ offLabel }}</p>
    <button (click)="onClick()" class="toggle-btn" [ngClass]="{'toggle-btn-on': on, 'toggle-btn-off': !on}" [attr.aria-expanded]="on" ></button>
    <p *ngIf="onLabel" class="label label--after">{{ onLabel }}</p>
  </div>
</div>
